export * from "./PhoneValidationContent";
export * from "./PhoneValidationComponent";
